export default () => ({
  videoId: null,
  aspectRatio: 16 / 9,
  cover: false,
  controls: true,
  playbar: true,
  iframe: null,
  container: null,
  checkInterval: null,

  init() {
    const el = this.$el;
    this.videoId = el.dataset.videoId;
    this.aspectRatio = parseFloat(el.dataset.aspectRatio) || 16 / 9;
    this.cover = el.dataset.cover === 'true';
    this.controls = el.dataset.controls !== 'false';
    this.playbar = el.dataset.playbar !== 'false';

    if (!this.videoId) return;

    if (this.cover) {
      this.container = el;
      this.iframe = el.querySelector('.hero-video-iframe');
      if (this.iframe) this.setupCoverEffect();
    }
  },

  setupCoverEffect() {
    this.iframe.addEventListener('load', () => this.applyCoverEffect());
    this.applyCoverEffect();
    this.checkInterval = setInterval(() => this.applyCoverEffect(), 300);
    window.addEventListener('resize', () => this.applyCoverEffect());
  },

  applyCoverEffect() {
    if (!this.container || !this.iframe) return;

    const cw = this.container.offsetWidth;
    const ch = this.container.offsetHeight;
    const wider = cw / ch > this.aspectRatio;
    const width = wider ? cw : ch * this.aspectRatio;
    const height = wider ? cw / this.aspectRatio : ch;

    Object.entries({
      width: `${width}px`,
      height: `${height}px`,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 'none',
      maxHeight: 'none',
    }).forEach(([k, v]) => this.iframe.style.setProperty(k, v, 'important'));
  },

  destroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
});
